import $ from "jquery";

export default class TIP {
    constructor(translations = {}, addCallback = () => {}, newFormContainer) {
        this.translations = translations;
        this.addCallback = addCallback;
        this.newFormContainer = newFormContainer || document.createElement("li");
        this.index = 0;
    }

    addForm(collection, addLinkElement) {

        // Verify if blocs already exists and affect number of blocs in index object
        if(collection.getElementsByClassName('dfs-bloc').length) {
            this.index = parseInt(collection.getAttribute('data-index'));
        }

        // Replace '__name__' in the prototype's HTML to
        // instead be a number based on how many items we have
        const newForm = collection.dataset.prototype.replace(/__name__/g, this.index);

        // increase the index with one for the next item
        this.index += 1;
        collection.setAttribute('data-index', this.index);

        const newBlock = this.newFormContainer.cloneNode(true);
        newBlock.insertAdjacentHTML("beforeend", newForm);

        addLinkElement.parentNode.insertBefore(newBlock, addLinkElement);

        // add a delete link to the new form
        this.addFormDeleteLink(newBlock);

        if (typeof this.addCallback === "function") {
            this.addCallback(newBlock);
        }
    }

    addFormDeleteLink(block) {
        block.insertAdjacentHTML(
            "beforeend",
            this.translations.delete
                ? `<a href="#">${this.translations.delete}</a>`
                : "<div class='remove-button'></div>",
        );

        block.lastChild.addEventListener("click", (event) => {
            event.preventDefault();
            block.remove();
        });
    }

    initFormCollection(collection, uniqid, defaultEntry) {
        // setup an "add a tag" link
        const addLinkElement = document.createElement("a");
        addLinkElement.setAttribute("href", "#");
        addLinkElement.setAttribute("class", `dfs-link add_${uniqid} d-b pt-1 c-main-scd`);
        addLinkElement.innerText = this.translations.add;

        collection.appendChild(addLinkElement);

        if(collection.getElementsByClassName('dfs-bloc').length) {
            let arrayRemoveButton = collection.querySelectorAll(".remove-button");
            arrayRemoveButton.forEach(function(el) {
                el.addEventListener('click', event => {
                    event.preventDefault();
                    event.target.offsetParent.remove();
                });
            });
        }

        addLinkElement.addEventListener('click', event => {
            event.preventDefault();
            this.addForm(collection, addLinkElement);
            collection.dispatchEvent(new Event("contentChanged"));
        });

        if (defaultEntry === "true" && this.index === 0) {
            this.addForm(collection, addLinkElement);
        }
    }

    // Add select to any given arg
    initSelect2(element, data, processResults) {
        const dataCallback = data || function (params) {
            return {q: params.term}
        };

        const processResultsCallback = processResults || function (data) {
            return {results: data}
        };

        const url = element.dataset.url;
        const minimumInput = element.dataset.minimumInput || 2;

        const params = url ? {
            ajax: {
                url,
                data: dataCallback,
                processResults: processResultsCallback,
            },
            minimumInputLength: minimumInput
        } : {};

        $(element).select2(params);
    };
}
